<div class="dropdown-holder">
  <label class="label">{{ label }}</label>
  <select [(ngModel)]="selectedValue" (change)="onSelectionChange()">
    <option class="text" *ngFor="let option of options" [value]="option.value">{{ option.label }}</option>
  </select>
</div>
